'use strict';

const debounce = require('lodash/debounce');

/**
 *
 * @param {*} productItemSelector product item selector
 * @param {*} gridContainerSelector grid selector
 * @returns {null | number} grid row position
 */
const getProductItemRow = (productItemSelector, gridContainerSelector) => {
    const productItem = $(productItemSelector);
    const gridContainer = $(gridContainerSelector);

    const $baseTile = $('.product-item-wrapper').first();
    let cellHeight = $baseTile.outerHeight();
    let cellWidth = $baseTile.outerWidth();

    if (cellHeight === 0 || cellWidth === 0) {
        cellHeight = gridContainer.outerHeight() / gridContainer.children().length;
        cellWidth = gridContainer.outerWidth() / gridContainer.children().length;
        if (Number.isNaN(cellHeight) || Number.isNaN(cellWidth) || cellHeight === 0 || cellWidth === 0) {
            return null;
        }
    }

    const offset = productItem.offset();
    if (!offset) {
        return null;
    }
    const gridOffset = gridContainer.offset();

    const topOffsetDiff = offset.top - gridOffset.top;

    const rowIndex = Math.max(1, Math.floor(topOffsetDiff / cellHeight) + 1);

    return rowIndex;
};

/**
 *
 * @param {*} tile product item selector
 * @param {*} grid grid selector
 * @returns {null | number} grid row position
 */
const getMarketingTileRow = (tile, grid) => {
    const $tile = $(tile);
    const $grid = $(grid);

    const $baseTile = $('.product-item-wrapper').first();
    const offset = $tile.offset();
    const gridOffset = $grid.offset();
    const cellHeight = $baseTile.outerHeight();

    return Math.floor((offset.top - gridOffset.top) / cellHeight) + 1;
};

/**
 * Adjust marketing tile after page load
 */
function adjustMarketingTileHeight() {
    const $gridContainer = $('.product-grid');
    const $marketingTile = $('.marketing-tile');

    for (let i = 0; i < $marketingTile.length; i++) {
        const $tile = $marketingTile.eq(i);

        const adjustTileHeight = () => {
            const $size11 = $tile.find('.size-ccb-1x1');
            const $size12 = $tile.find('.size-ccb-1x2');
            const $size22 = $tile.find('.size-ccb-2x2');
            const size11length = $size11.length;
            const size12length = $size12.length;
            if (size11length || size12length) {
                if ((size11length && $size11.html() === '') || (size12length && $size12.html() === '')) {
                    $tile.addClass('hide');
                }
                const mtPosition = parseInt($tile.data('plp-position'), 10);
                const $adjascentTile = $(`.product-item-wrapper[data-position="${mtPosition.toFixed(1)}"]`);
                let adjascentTileImgBottom = '';
                if (size11length) {
                    adjascentTileImgBottom = $adjascentTile.find('img').height();
                } else if ($tile.find('.dun-marketing-tile').length) {
                    if (app.isDesktop()) {
                        adjascentTileImgBottom = $adjascentTile.find('img').height();
                    }
                } else if (app.isDesktop()) {
                    adjascentTileImgBottom = $adjascentTile.height() * 0.95;
                } else if (app.isTablet()) {
                    adjascentTileImgBottom = $adjascentTile.height() * 0.9;
                }

                $tile.find('img').css('height', adjascentTileImgBottom);
                $tile.find('.video-asset-wrapper').css('--video-height', adjascentTileImgBottom + 'px');
            }

            if (size11length) {
                $tile.addClass('has-size-ccb-1x1');
            }

            if (size12length) {
                $tile.addClass('has-size-ccb-1x2');
            }

            if ($size22.length) {
                if ($size22.html() === '') {
                    $tile.addClass('hide');
                }
                $tile.addClass('has-size-ccb-2x2');

                const mtRowIndex = getMarketingTileRow($tile, $gridContainer);
                const mtPosition = parseInt($tile.data('plp-position'), 10);
                const $adjascentTile = $(`.product-item-wrapper[data-position="${mtPosition.toFixed(1)}"]`);

                const adjascentTileRow = getProductItemRow($adjascentTile, $gridContainer);

                if ([mtRowIndex, mtRowIndex + 1].includes(adjascentTileRow)) {
                    const refTileHeight = $adjascentTile.height();
                    const $refTileImg = $adjascentTile.find('img');
                    const refTileImgHeight = $refTileImg.height();
                    const $parentWrapper = $tile.parents('.product-grid');
                    const parentGapHeight = parseInt($parentWrapper.css('gap').split(' ')[0], 10);
                    const totalHeight = refTileHeight + refTileImgHeight + parentGapHeight;
                    if (app.isDesktop()) {
                        $tile.find('img').css('height', totalHeight);
                        $tile.find('.video-asset-wrapper').css('--video-height', totalHeight + 'px');
                    } else {
                        $tile.find('img').css('height', 'auto');
                    }
                }
            }
        };

        adjustTileHeight();

        const observer = new MutationObserver(adjustTileHeight);
        const config = { attributes: true, childList: true, subtree: true };

        const $elementsToObserve = [];

        if ($tile.find('.size-ccb-2x2').length) {
            const mtPosition = parseInt($tile.data('plp-position'), 10);
            const $adjascentTile = $(`.product-item-wrapper[data-position="${mtPosition.toFixed(1)}"]`);

            $elementsToObserve.push($adjascentTile[0]);
            const $refTileImg = $adjascentTile.find('img');
            if ($refTileImg.length) {
                $elementsToObserve.push($refTileImg[0]);
            }

            $elementsToObserve.push($gridContainer[0]);

            if ($elementsToObserve.length > 0) {
                $elementsToObserve.forEach((element) => {
                    debounce(function () {
                        observer.observe(element, config);
                    }, 100);
                });
            }
        }

        $tile.data('observer', observer);
    }
}

let resizeTimeout;
$(() => {
    $(window).on('load', adjustMarketingTileHeight());
    $(window).on('resize', function () {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(adjustMarketingTileHeight, 200);
    });
    $('body').on('search:updateDom', () => {
        adjustMarketingTileHeight();
    });
});
